<div class="profile-card">
<mat-card class = "profile-card-align-middle" [routerLink]="['/our-team-detail', profile.id]">
  <mat-card-header class = "profile-card-header">
    <img mat-card-xl-image
         class = "profile-card-image"
         [ngSrc]="profile.url" fill priority
         [style.object-position]="profile.centerX + ' ' + profile.centerY"
         alt="Exterior photo of {{ profile.title }} {{ profile.firstname}} {{ profile.lastname}}"
         crossorigin>
  </mat-card-header>

    <mat-card-title-group>
      <mat-card-title>{{ profile.title }} {{ profile.firstname}} {{ profile.lastname}}</mat-card-title>
          </mat-card-title-group>
  <mat-card-footer class = "profile-card-footer">
   <div>
     <mat-card-subtitle>{{profile.role}}</mat-card-subtitle>
    {{profile.qual}}
   </div>
  </mat-card-footer>
      </mat-card>
</div>
